import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Expose API base for sendBeacon (used in CartContext beforeunload)
window._gwApiBase = API_BASE_URL;

// Derives image host from API URL - strips /api suffix
// e.g. https://yourdomain.com/api &#8594; https://yourdomain.com
export const IMAGE_BASE_URL = API_BASE_URL.replace(/\/api\/?$/, '');

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 8000,
  headers: { 'Content-Type': 'application/json' }
});

// Automatically attach JWT token from sessionStorage on admin requests only
api.interceptors.request.use(config => {
  const token = sessionStorage.getItem('adminToken');
  if (token && config.url && (config.url.includes('/admin/') || config.url.includes('/upload'))) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

export const fetchMenu = async () => {
  const { data } = await api.get('/menu');
  return data;
};

export const fetchContent = async (section) => {
  const { data } = await api.get(`/content/${section}`);
  return data;
};

export const fetchProducts = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const { data } = await api.get(`/products${query ? '?' + query : ''}`);
  return data;
};

export const fetchTestimonials = async () => {
  const { data } = await api.get('/testimonials');
  return data;
};

export const fetchBranding = async () => {
  const { data } = await api.get('/branding');
  return data;
};

export const fetchSlides = async () => {
  const { data } = await api.get('/slides');
  return data;
};

// Google's overall rating + review count (saved by the admin's SerpApi import): { rating, total }
export const fetchReviewsSummary = async () => {
  const { data } = await api.get('/reviews/summary');
  return data;
};

export const fetchReviews = async () => {
  const { data } = await api.get('/reviews');
  return data;
};

export const submitContact = async (formData) => {
  const { data } = await api.post('/contact', formData);
  return data;
};

export const uploadImage = async (file) => {
  const form = new FormData();
  form.append('image', file);
  const token = sessionStorage.getItem('adminToken');
  const { data } = await axios.post(`${API_BASE_URL}/upload`, form, {
    headers: {
      ...(token ? { 'Authorization': `Bearer ${token}` } : {})
    }
  });
  return data.url;
};

export const getImageUrl = (url, width) => {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  const base = `${IMAGE_BASE_URL}${url.startsWith('/') ? '' : '/'}${url}`;
  return width ? `${base}?w=${width}` : base;
};

export default api;
